export default "__VITE_ASSET__C4GNC4gW__"